import React, { useEffect } from 'react'

export const TERMS_VERSION = '1.0'

export default function FinancingTermsModal({
  open,
  onClose
}) {

    useEffect(() => {

  if (!open) {
    return
  }

  const previousOverflow =
    document.body.style.overflow

  document.body.style.overflow = 'hidden'

  return () => {
    document.body.style.overflow =
      previousOverflow
  }

}, [open])

  if (!open) {
    return null
  }

return (

  <div
    className="
      fixed
      inset-0
      z-[9999]
      bg-black/50
      flex
      items-center
      justify-center
      px-4
      py-6
    "
    onClick={onClose}
  >

        <div
  className="
    bg-white
    w-full
    max-w-3xl
    rounded-2xl
    shadow-xl
    overflow-hidden
    font-[Lexend]
  "
  style={{
    height: '90vh'
  }}
  onClick={(e) =>
    e.stopPropagation()
  }
>

        {/* HEADER */}

        <div
  className="
    shrink-0
    px-6
    py-5
    border-b
    border-gray-100
    flex
    items-start
    justify-between
    gap-4
  "
>

          <div>

            <p
              className="
                text-xs
                font-bold
                text-green-600
                uppercase
                tracking-wide
              "
            >
              Financing Agreement
            </p>

            <h2
              className="
                text-xl
                font-bold
                text-gray-900
                mt-1
              "
            >
              RentHub Rent Financing Agreement
            </h2>

            <p
              className="
                text-xs
                text-gray-500
                mt-1
              "
            >
              Version {TERMS_VERSION}
            </p>

          </div>


          <button
            type="button"
            onClick={onClose}
            className="
              w-9
              h-9
              shrink-0
              rounded-full
              bg-gray-100
              hover:bg-gray-200
              text-gray-600
              font-bold
              transition
            "
          >
            ✕
          </button>

        </div>


        {/* TERMS */}

<div
  className="
    px-6
    md:px-8
    py-6
    text-sm
    text-gray-600
    leading-7
    space-y-7
  "
  style={{
    overflowY: 'auto',
    height: 'calc(90vh - 180px)',
    WebkitOverflowScrolling: 'touch'
  }}
>
          <TermsSection title="1. Purpose of the Financing">

            <p>
              RentHub is a product of Rivmev Services and
              provides rent financing that allows an approved
              tenant to have eligible rent paid directly to
              their landlord and repay RentHub over an agreed
              repayment period.
            </p>

            <p>
              Submitting an application does not guarantee
              approval. RentHub may approve, decline, request
              additional information, require manual review or
              require additional verification before proceeding.
            </p>

          </TermsSection>


          <TermsSection title="2. Information Provided by the Tenant">

            <p>
              You confirm that all information supplied in your
              application is complete, accurate and not
              misleading.
            </p>

            <p>
              This includes your identity information, BVN,
              contact details, residential address, rental
              property information, landlord information,
              landlord physical address, landlord bank
              information and requested rent amount.
            </p>

            <p>
              RentHub may reject or cancel an application where
              information cannot be verified or is reasonably
              believed to be false, misleading or fraudulent.
            </p>

          </TermsSection>


          <TermsSection title="3. Credit Assessment">

            <p>
              By submitting an application, you authorise
              RentHub to use your BVN and other information
              provided by you to obtain and assess relevant
              credit information from permitted credit bureaus,
              credit information providers and other authorised
              sources.
            </p>

            <p>
              RentHub may use this information together with
              its internal underwriting systems when deciding
              whether financing should be offered.
            </p>

          </TermsSection>


          <TermsSection title="4. Financing Amount">

            <p>
              The rent amount requested is not automatically
              the amount RentHub is required to finance.
            </p>

            <p>
              RentHub may approve the requested amount, approve
              another amount where permitted and accepted by
              you, or decline the application.
            </p>

          </TermsSection>


          <TermsSection title="5. Financing Charge">

            <p>
              Where financing is approved, RentHub currently
              applies a financing charge of 20% of the approved
              rent amount unless a different charge is clearly
              disclosed and accepted before financing.
            </p>

            <ExampleBox>
              Approved rent: ₦250,000
              <br />
              Financing charge: ₦50,000
              <br />
              Total repayment: ₦300,000
            </ExampleBox>

          </TermsSection>


          <TermsSection title="6. Repayment Period">

            <p>
              Unless otherwise stated in the approved financing
              terms, repayment will be spread over 12 months.
            </p>

            <ExampleBox>
              Total repayment: ₦300,000
              <br />
              Repayment period: 12 months
              <br />
              Monthly repayment: ₦25,000
            </ExampleBox>

          </TermsSection>


          <TermsSection title="7. Physical Verification">

            <p>
              Approval may be subject to successful physical
              verification.
            </p>

            <p>
              You consent to RentHub or an authorised
              representative visiting locations relevant to
              your application, including your residential
              address, your landlord's stated address and the
              property being financed.
            </p>

            <p>
              Verification may include confirming that the
              addresses and property exist, confirming your
              connection to the residence, confirming landlord
              information and identifying material
              inconsistencies in the application.
            </p>

          </TermsSection>


          <TermsSection title="8. Photographs During Physical Verification">

            <p>
              You consent to reasonable photographs being taken
              where necessary to document the physical
              verification.
            </p>

            <p>
              This may include photographs of the exterior of
              your residence, relevant areas necessary to
              confirm the residence, the landlord verification
              location, and the exterior or entrance of the
              rental property.
            </p>

            <p>
              RentHub should not intentionally collect
              photographs unrelated to the financing or
              verification process.
            </p>

          </TermsSection>


          <TermsSection title="9. Landlord Verification">

            <p>
              You authorise RentHub to contact your landlord
              using the information supplied in your
              application.
            </p>

            <p>
              RentHub may verify the landlord's identity or
              contact details, the rent amount, the property,
              the proposed tenancy, the landlord's bank details
              and other information reasonably necessary to
              verify the transaction.
            </p>

          </TermsSection>


          <TermsSection title="10. Direct Payment to the Landlord">

            <p>
              If RentHub proceeds with the financing, the
              approved rent will ordinarily be paid directly
              into the landlord's verified bank account and
              not to you.
            </p>

            <p>
              You are responsible for supplying accurate
              landlord payment information.
            </p>

          </TermsSection>


          <TermsSection title="11. When the Financing Becomes Active">

            <p>
              Approval alone does not mean that the financing
              has started.
            </p>

            <p>
              The financing becomes active only after RentHub
              successfully disburses the approved rent to the
              landlord and confirms the successful transfer.
            </p>

            <p>
              If the landlord is never successfully paid, you
              will not owe repayments for money that was never
              successfully disbursed.
            </p>

          </TermsSection>


          <TermsSection title="12. Repayments">

            <p>
              Once the financing becomes active, you agree to
              repay RentHub according to the repayment schedule
              provided to you.
            </p>

            <p>
              You are responsible for ensuring that repayments
              are made when due.
            </p>

          </TermsSection>


          <TermsSection title="13. Missed Payments and Default">

            <p>
              You may be considered in default if you fail to
              make required repayments, repeatedly fail to
              comply with your repayment schedule, deliberately
              attempt to avoid repayment, provide materially
              false information or materially breach this
              Agreement.
            </p>

            <p>
              Being in default does not cancel or reduce any
              amount that you lawfully owe RentHub.
            </p>

          </TermsSection>


          <TermsSection title="14. Recovery of Outstanding Amounts">

            <p>
              If you fail to make repayments when due, RentHub
              reserves the right to take all lawful and
              reasonable steps necessary to recover amounts
              properly owed under this Agreement.
            </p>

            <p>
              Such steps may include contacting you regarding
              the debt, requesting payment, using payment
              methods or mandates validly authorised by you,
              engaging authorised debt-recovery professionals,
              reporting repayment performance to permitted
              credit-reporting bodies, commencing legal
              proceedings and exercising other lawful recovery
              remedies.
            </p>

            <p>
              You may also be responsible for reasonable
              recovery, court or legal costs where such costs
              may lawfully be recovered from you.
            </p>

            <p>
              Nothing in this Agreement permits harassment,
              threats, unlawful seizure of property, public
              shaming or any action prohibited by law.
            </p>

          </TermsSection>


          <TermsSection title="15. Credit Reporting">

            <p>
              Where permitted, RentHub may report information
              about your financing and repayment performance to
              authorised credit bureaus or other permitted
              credit-reporting bodies.
            </p>

            <p>
              This may include successful repayments,
              outstanding obligations, late repayments and
              defaults.
            </p>

          </TermsSection>


          <TermsSection title="16. Fraud and False Information">

            <p>
              RentHub may suspend, reject or cancel an
              application where it reasonably suspects fraud,
              impersonation, falsified information, false
              landlord details, manipulated payment information
              or another material misrepresentation.
            </p>

          </TermsSection>


          <TermsSection title="17. Cancellation Before Disbursement">

            <p>
              RentHub may cancel an approved application before
              disbursement where verification fails,
              information is inaccurate, fraud is suspected,
              the landlord or property cannot be verified, the
              proposed transaction materially changes or
              RentHub cannot lawfully proceed.
            </p>

            <p>
              Cancellation before successful disbursement does
              not create a repayment obligation for money that
              was never disbursed.
            </p>

          </TermsSection>


          <TermsSection title="18. Failed Disbursement">

            <p>
              If a landlord payment fails, RentHub may retry
              the payment, request corrected bank information,
              conduct additional verification or cancel the
              proposed financing.
            </p>

            <p>
              Financing does not become active merely because
              RentHub attempted a transfer.
            </p>

          </TermsSection>


          <TermsSection title="19. Personal Information">

            <p>
              You authorise RentHub to collect, use, verify,
              store and process information reasonably
              necessary to process your application, conduct
              credit and identity checks, perform physical
              verification, prevent fraud, contact your
              landlord, disburse rent, manage repayments,
              recover outstanding debts and satisfy legal or
              regulatory obligations.
            </p>

            <p>
              Necessary information may be shared with service
              providers used for payments, identity
              verification, credit information,
              communications and verification where required
              for those purposes.
            </p>

          </TermsSection>


          <TermsSection title="20. Application Decisions">

            <p>
              RentHub reserves the right to approve or decline
              an application according to its eligibility,
              credit, fraud, verification and risk
              requirements.
            </p>

          </TermsSection>


          <TermsSection title="21. Communication">

            <p>
              You agree that RentHub may contact you regarding
              your application or financing using the contact
              information supplied by you, including email,
              telephone and SMS.
            </p>

          </TermsSection>


          <TermsSection title="22. Complaints and Disputes">

            <p>
              If you believe there is an error concerning your
              application, disbursement, repayment balance or
              financing, you should contact RentHub as soon as
              possible.
            </p>

          </TermsSection>


          <TermsSection title="23. Changes to this Agreement">

            <p>
              The version of this Agreement accepted for your
              application will be recorded against that
              application.
            </p>

            <p>
              Future changes to RentHub's terms will not
              silently replace the version associated with your
              existing application.
            </p>

          </TermsSection>


          <TermsSection title="24. Electronic Signature">

            <p>
              By typing your full legal name, checking the
              agreement box and submitting your application,
              you confirm that you have read and understood
              this Agreement and voluntarily agree to its
              terms.
            </p>

            <p>
              You also confirm your consent to the credit
              assessment and physical verification processes
              described above and confirm that the information
              supplied by you is true to the best of your
              knowledge.
            </p>

          </TermsSection>


          <TermsSection title="25. Applicable Law">

            <p>
              This Agreement will be interpreted in accordance
              with applicable Nigerian law.
            </p>

            <p>
              Nothing in this Agreement limits any right or
              protection that cannot lawfully be excluded.
            </p>

          </TermsSection>

        </div>


        {/* FOOTER */}

        <div
  className="
    shrink-0
    border-t
    border-gray-100
    px-6
    py-4
    bg-gray-50
  "
>

          <button
            type="button"
            onClick={onClose}
            className="
              w-full
              bg-gray-900
              hover:bg-black
              text-white
              py-3
              rounded-xl
              font-semibold
              transition
            "
          >
            I have finished reading
          </button>

        </div>

      </div>

    </div>

  )
}


function TermsSection({
  title,
  children
}) {

  return (

    <section>

      <h3
        className="
          font-bold
          text-gray-900
          mb-2
        "
      >
        {title}
      </h3>

      <div className="space-y-3">
        {children}
      </div>

    </section>

  )
}


function ExampleBox({
  children
}) {

  return (

    <div
      className="
        bg-gray-50
        border
        border-gray-200
        rounded-xl
        px-4
        py-3
        text-gray-700
        font-medium
      "
    >
      {children}
  </div>
)

}